import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Study } from '@/shared/api/protocol-ts/model/dto_study_pb';

import { ReportCardLayout } from '@/features/reportCards';

import { useRawMeshViewerCard, useRawMeshViewerCardActions } from '../../hooks';
import { RawMeshViewerActionsPopover } from '../RawMeshViewerActionsPopover/RawMeshViewerActionsPopover';

type RawMeshViewerCardProps = {
  study: Study;
  className?: string;
  testID?: string;
};

export const RawMeshViewerCard: FC<RawMeshViewerCardProps> = (props) => {
  const { study, className, testID } = props;

  const { formatDate } = useIntl();
  const { title, uploadDate, previewSrc, handleCardClick } =
    useRawMeshViewerCard(study);
  const { isRemoving, CanDelete, openRemoveConfirmModal, openInfoModal } =
    useRawMeshViewerCardActions(study);

  const handleMobileInfoClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    openInfoModal();
  };

  return (
    <ReportCardLayout
      data-component="raw-mesh-viewer-card"
      className={className}
      date={
        uploadDate ? formatDate(uploadDate, { dateStyle: 'medium' }) : undefined
      }
      desktopActions={
        <RawMeshViewerActionsPopover
          canDelete={CanDelete}
          onShowInfo={openInfoModal}
          onRemove={openRemoveConfirmModal}
        />
      }
      isGenerationCompleted
      isRemoving={isRemoving}
      onClick={isRemoving ? undefined : handleCardClick}
      onMobileActionsClick={handleMobileInfoClick}
      previewAlt={title}
      previewSrc={previewSrc}
      testID={testID}
      title={title}
    />
  );
};
